import { type ReduxApplicationState } from 'src/redux/combinedReducer';
import { type SortOption } from 'src/redux/productsQuery/types/SortOption';
import { getListingsSortAsURLSearchParams } from '../listings-api/getListingsSortAsURLSearchParams';

type StoreToPageURLState = Pick<ReduxApplicationState, 'productsQuery'>;

export type BuildListingsQueryParamsOptions = {
  page?: number;
  sortOption?: SortOption | null;
};

export const appendListingsQueryParams = (
  urlParams: URLSearchParams,
  state: StoreToPageURLState,
  options: BuildListingsQueryParamsOptions = {},
): void => {
  const {
    productsQuery: { searchTerm, sortOptions = [] },
  } = state;
  const { page, sortOption = undefined } = options;
  const activeSortOption =
    sortOption === undefined ? sortOptions.find((option) => option.active) : sortOption;

  if (activeSortOption?.key) {
    getListingsSortAsURLSearchParams(urlParams, activeSortOption);
  }

  // don't include page=1 as that is the default
  if (page && page > 1) {
    urlParams.set('page', page.toString());
  }

  if (searchTerm) {
    urlParams.set('term', searchTerm);
  }
};

/**
 * Returns non-facet query params only (sort, page, term).
 * Facet filters are serialised into the URL path by the product-listings-urls `build`.
 */
export const buildListingsQueryParams = (
  state: StoreToPageURLState,
  options: BuildListingsQueryParamsOptions = {},
): URLSearchParams => {
  const urlParams = new URLSearchParams();
  appendListingsQueryParams(urlParams, state, options);
  return urlParams;
};
